import { render, staticRenderFns } from "./CollectionGroupPerformance.vue?vue&type=template&id=77618ed9&scoped=true"
import script from "./CollectionGroupPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionGroupPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionGroupPerformance.vue?vue&type=style&index=0&id=77618ed9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77618ed9",
  null
  
)

export default component.exports